import React from 'react';
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  YoutubeIcon,
} from '../../../common/SocialMediaIcons.jsx';
import { envData } from '../../../../environments.js';
import { useAppSelector } from '../../../../store/store';
import { storeIdentifierNameSelector } from '../../../../store/selectors/commonSelector';
import './FundSiteFooterSocialLinks.scss';

export default function FundSiteFooterSocialLinks() {
  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);
  return (
    <div className="footerSocialLinks-container">
      <TwitterIcon link={envData[storeIdentifierName].socialLinks.twitter} />
      <FacebookIcon
        link={envData[storeIdentifierName].socialLinks.facebook}
        classes="footer-facebook-icon"
      />
      <InstagramIcon link={envData[storeIdentifierName].socialLinks.instagram} />
      <YoutubeIcon link={envData[storeIdentifierName].socialLinks.youtube} />
    </div>
  );
}
